import { Component, Input, ContentChildren, QueryList } from '@angular/core';
import { TableHeaderComponent } from '../table-header/table-header.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'gbc-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    imports: [NgClass],
})
export class TableComponent {
  @Input()
  public clickableRows: boolean;
  @Input()
  public selectableRows: boolean;
  @Input()
  public suppressAutoAddChevronHeader: boolean;
  @Input()
  public stickyHeaders: boolean;

  @ContentChildren(TableHeaderComponent)
  public headers: QueryList<TableHeaderComponent>;

  constructor() {}
}
